import { useState, useContext, useEffect, useCallback } from 'react'

import clsx from 'clsx'
import { AppBar, Box, Typography, IconButton  } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'

import constants from '../../constants/languages'
import appContext from '../../utils/app-context'
import { REGISTRATION_ROUTE, FORGOTPWD_ROUTE, LOGIN_ROUTE, MAGIC_LINK } from '../../constants/routes'
import rbcLogoEn from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_en.svg?url'
import rbcLogoEnLight from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_en_light.svg?url'
import rbcLogoFr from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_fr.svg?url'
import rbcLogoFrLight from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_light_fr.svg?url'
import LanguageButtonAppbar from '../language-button-appbar'
import SUPPORTED_THEMES from '../../constants/theme'
import styles from './styles'


const Component = ({
    classes
}) => {
    const { application: applicationContext } = useContext(appContext)
    const { loginTitle } = applicationContext
    const { i18n, t: translate } = useTranslation()
    const [ currentRoute, setCurrentRoute ] = useState(LOGIN_ROUTE)
    const { theme, updateTheme } = useAuraThemeSwitcher()
    document.title = translate(loginTitle)
    const RBC_THEME_BASED_LOGO = {
        [constants.ENGLISH]: {
            [SUPPORTED_THEMES.DARK]: rbcLogoEnLight,
            [SUPPORTED_THEMES.LIGHT]: rbcLogoEn
        },
        'default': {
            [SUPPORTED_THEMES.DARK]: rbcLogoFrLight,
            [SUPPORTED_THEMES.LIGHT]: rbcLogoFr
        }
    }

    useEffect(() => {
        switch (true) {
            case window.location.pathname.includes(FORGOTPWD_ROUTE):
                setCurrentRoute(FORGOTPWD_ROUTE)
                break
            case window.location.pathname.includes(REGISTRATION_ROUTE):
                setCurrentRoute(REGISTRATION_ROUTE)
                break
            case window.location.pathname.includes(LOGIN_ROUTE):
                setCurrentRoute(LOGIN_ROUTE)
                break
            case window.location.pathname.includes(MAGIC_LINK):
                setCurrentRoute(MAGIC_LINK)
                break    
            default:
                setCurrentRoute(LOGIN_ROUTE)
                break
        }
    }, [])

    const ThemeMenu = ({ classes, theme, updateTheme }) => {
        const { LIGHT, DARK } = SUPPORTED_THEMES

        const setTheme = mode => {
            updateTheme({ palette: mode })
            localStorage.setItem('theme', mode)
        }
        return (
            <>
                <IconButton
                    color="inherit"
                    onClick={() => setTheme(theme.palette.mode === LIGHT ? DARK : LIGHT)}
                >
                    <Box className={classes.themeIconBox}>
                        {theme.palette.mode === SUPPORTED_THEMES.DARK ? (
                            <LightModeOutlinedIcon
                                className={clsx(classes.themeIcon)}
                            />
                        ) : (
                            <DarkModeOutlinedIcon
                                className={clsx(classes.themeIcon)}
                            />
                        )}
                    </Box>
                </IconButton>
            </>
        )
    }
    const openLogoLink = useCallback(() => {
        window.open(translate('homeLink'), '_blank')
    }, [ translate ])

    return (<div className={classes.root}>
        <AppBar className={clsx(classes.appBar)} color='inherit'>
            <Box className={clsx(classes.logoContainer)} onClick={openLogoLink}>
                {i18n.language === constants.ENGLISH ? (
                    <img className={classes.logoEn} src={RBC_THEME_BASED_LOGO[constants.ENGLISH][theme.palette.mode]} />
                ) : (
                    <img className={classes.logoFr} src={RBC_THEME_BASED_LOGO['default'][theme.palette.mode]} />
                )}
            </Box>
            
            <Box className={classes.titleBox}>
                <Typography className={classes.title}>
                    {translate('rbccmTitle')}
                </Typography>
            </Box>
            <Box className={classes.divider1}></Box>
                
              
            <Box className={classes.menuItemsGroup1}>
                <LanguageButtonAppbar clsName='languageButton' showTitle={false} component={currentRoute} loginTitle={loginTitle} variant='text'></LanguageButtonAppbar>
                <Box>
                    <ThemeMenu classes={classes} theme={theme} updateTheme={updateTheme} />
                </Box>
            </Box>
            <Box className={classes.divider2}></Box>
        </AppBar>
    </div>)
}
Component.propTypes = {
    classes: PropTypes.shape({
        appBar: PropTypes.object,
        appBarShift: PropTypes.object,
        button: PropTypes.object,
        fullHeight: PropTypes.object,
        group: PropTypes.object,
        hide: PropTypes.object,
        item: PropTypes.object,
        logo: PropTypes.object,
        menu: PropTypes.object,
        menuButton: PropTypes.object,
        menuContent: PropTypes.object,
        menuItem: PropTypes.object,
        navPopoverPaper: PropTypes.object,
        noPadding: PropTypes.object,
        root: PropTypes.object,
        title: PropTypes.object,
        titleShift: PropTypes.object,
        toolbar: PropTypes.object,
        ultraSmall: PropTypes.object
    })
}

export default withStyles(Component, styles)
